import * as yup from "yup";

const FirstNameValidation = yup.string().required('First name cannot be left blank.')

const LastNameValidation = yup.string().required('Last name cannot be left blank.')

const EmailValidation = yup.string()
    .email('Invalid Email Address specified. Use format \'user@example.com\'.')
    .required('Email cannot be left blank.')

const MobileValidation = yup.number()
    .typeError('Mobile number is a numeric field. Please only enter digits.')
    .required('Mobile number cannot be left blank.')
    .min(0, 'Mobile number has to be greater than 0')

const PhoneValidation = yup.number()
    .typeError('Phone number is a numeric field. Please only enter digits.')
    .required('Phone number cannot be left blank.')
    .min(0, 'Phone number has to be greater than 0')

export const TermsAndConditionsValidation = yup.boolean()
    .required('Terms and conditions is required')
    .oneOf([true], "The terms and conditions must be accepted.")

const RecaptchaValidation = yup.string().required('You must complete reCaptcha validation').nullable();

export {
    FirstNameValidation,
    LastNameValidation,
    EmailValidation,
    MobileValidation,
    PhoneValidation,
    RecaptchaValidation
}
